
import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CurrencyPricePipe } from '@delon/util';

interface ReceivePaymentPreviewItem {
  type: string;
  date: string;
  docNo: string;
  description: string;
  outstanding: number;
  amount: number;
  payment: number;
}

@Component({
  selector: 'app-transaction-preview-receive-payment',
  standalone: true,
  imports:[CurrencyPricePipe, DecimalPipe],  
  templateUrl: './transaction-preview-receive-payment.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransactionPreviewReceivePaymentComponent {
  @Input() currencyCode: string | null = null;
  @Input() items: ReceivePaymentPreviewItem[] | null = null;
  @Input() totalAmount: number | null = null;
  @Input() totalPayment: number | null = null;
  @Input() unmatchedAmount: number | null = null;
}
